module.exports = __webpack_public_path__ + "media/img/event/Sponsor-HTMi-0841750c0d335a8413c58ea16163e4e9.jpg";